import Vue from "vue";
import App from "./App.vue";
import store from "./store";

import { register } from "./initializeServiceWorker";
register();

Vue.config.productionTip = false;

let appStarted = false;
console.time("App Startup");
function startApp() {
  if (appStarted === false) {
    appStarted = true;
    console.timeEnd("App Startup");
    require("./messages");
    new Vue({
      store,
      render: h => h(App)
    }).$mount("#app");
  }
}

document.addEventListener(
  "deviceready",
  function() {
    if (appStarted) {
      console.warn("DEVICE READY TOOK LONGER THAN 3 SECONDS");
    } else {
      console.log("DEVICE IS READY");
      startApp();
    }
  },
  true
);

setTimeout(() => {
  if (!appStarted) {
    console.warn("DEVICE READY DID NOT FIRE?!? STARTING APP ANYWAYS...");
    startApp();
  }
}, 3000);

// This error usually means the iOS app is trying to load a javascript file that no longer exists
// because a new version has been pushed out.  To prevent this we just reload the app so all the
// resources can be downloaded fresh.
window.addEventListener("error", error => {
  console.log(error);
  if (/SyntaxError: Unexpected token '<'/.test(error.message)) {
    window.location.reload();
  }
});

window.addEventListener("scroll", event => {
  event.preventDefault();
  window.scrollTo(0, 0);
});
